export default __webpack_public_path__ + "static/media/68.128a360e.png";